import { render, staticRenderFns } from "./labelgroups-filter.vue?vue&type=template&id=0135dd3e"
import script from "./labelgroups-filter.vue?vue&type=script&lang=js"
export * from "./labelgroups-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports